import { useTranslation } from '@/src/i18n';
import { ScrollView, Text, TextInput, TouchableOpacity, View } from 'react-native';
import { createStyles } from '../TournamentDetailScreen.styles';

interface RulesTabProps {
  rules?: string;
  rulesText: string;
  setRulesText: (text: string) => void;
  editingRules: boolean;
  setEditingRules: (editing: boolean) => void;
  canManageParticipants: boolean;
  onSaveRules: () => void;
  onCancelRules: () => void;
  colors: {
    card: string;
    border: string;
    text: string;
    textSecondary: string;
    textTertiary: string;
    primary: string;
    primaryText: string;
  };
}

export const RulesTab = ({
  rules,
  rulesText,
  setRulesText,
  editingRules,
  setEditingRules,
  canManageParticipants,
  onSaveRules,
  onCancelRules,
  colors,
}: RulesTabProps) => {
  const styles = createStyles();
  const { t } = useTranslation();

  return (
    <ScrollView style={styles.tabContainer} contentContainerStyle={styles.settingsContent}>
      {canManageParticipants ? (
        <>
          {editingRules ? (
            <>
              <TextInput
                style={[
                  styles.rulesInput,
                  { backgroundColor: colors.card, borderColor: colors.border, color: colors.text },
                ]}
                placeholder={t('tournaments.rulesPlaceholder')}
                placeholderTextColor={colors.textTertiary}
                value={rulesText}
                onChangeText={setRulesText}
                multiline
                numberOfLines={15}
                textAlignVertical="top"
              />

              <View style={styles.rulesButtons}>
                <TouchableOpacity
                  style={[styles.rulesSaveButton, { backgroundColor: colors.primary }]}
                  onPress={onSaveRules}
                >
                  <Text style={[styles.rulesButtonText, { color: colors.primaryText }]}>{t('tournaments.saveRules')}</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={[styles.rulesCancelButton, { borderColor: colors.border }]}
                  onPress={onCancelRules}
                >
                  <Text style={[styles.rulesButtonText, { color: colors.text }]}>{t('common.cancel')}</Text>
                </TouchableOpacity>
              </View>
            </>
          ) : (
            <>
              {rules ? (
                <View style={[styles.rulesDisplay, { backgroundColor: colors.card, borderColor: colors.border }]}>
                  <Text style={[styles.rulesText, { color: colors.text }]}>{rules}</Text>
                </View>
              ) : (
                <View style={styles.noRulesContainer}>
                  <Text style={[styles.noRulesText, { color: colors.textSecondary }]}>
                    {t('tournaments.noRulesYet')}
                  </Text>
                  <Text style={[styles.noRulesSubtext, { color: colors.textTertiary }]}>
                    {t('tournaments.noRulesSubtext')}
                  </Text>
                </View>
              )}

              <TouchableOpacity
                style={[styles.editRulesButton, { backgroundColor: colors.primary }]}
                onPress={() => setEditingRules(true)}
              >
                <Text style={[styles.editRulesButtonText, { color: colors.primaryText }]}>
                  {rules ? t('tournaments.editRules') : t('tournaments.addRules')}
                </Text>
              </TouchableOpacity>
            </>
          )}
        </>
      ) : (
        <>
          {rules ? (
            <View style={[styles.rulesDisplay, { backgroundColor: colors.card, borderColor: colors.border }]}>
              <Text style={[styles.rulesText, { color: colors.text }]}>{rules}</Text>
            </View>
          ) : (
            <View style={styles.noRulesContainer}>
              <Text style={[styles.noRulesText, { color: colors.textSecondary }]}>{t('tournaments.noRulesYet')}</Text>
            </View>
          )}
        </>
      )}
    </ScrollView>
  );
};
